import React from 'react';
import { CatalogTag } from './CatalogTag';
import { Backdrop, Button, Card, Chip } from '@mui/material';

export const CatalogCard = ({
  catalogType,
  itemSelectText,
  onItemSelect,
  size = 50,
  tagFilter = [],
  disabled = false,
}: any) => {
  const [connectHover, setConnectHover] = React.useState(false);

  let image = null;
  if (catalogType.img_url) {
    image = (
      <img
        alt={catalogType.title}
        src={catalogType.img_url}
        style={{
          maxHeight: size + 'px',
          maxWidth: size + 'px',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      />
    );
  }

  const tags = [];

  if (catalogType.tags) {
    for (const tag of catalogType.tags) {
      tags.push(
        <CatalogTag
          title={tag.title}
          key={tag.name}
          highlighted={tagFilter.includes(tag.name)}
        />,
      );
    }
  }

  if (catalogType.release_status === 'preview') {
    tags.push(
      <CatalogTag
        title="Preview"
        key="preview"
        highlighted={tagFilter.includes('preview')}
        style={{
          background: '#bddcf4',
          color: '#000000',
        }}
      />,
    );
  }

  if (disabled) {
    tags.push(
      <Chip
        label="Locked"
        key="locked"
        size="small"
        variant="outlined"
        sx={{ fontSize: '10px', height: '20px', ml: 0.5 }}
      />,
    );
  }

  return (
    <Card
      style={{
        height: 145,
        fontFamily: 'Noto Sans,sans-serif',
        position: 'relative',
        ...(disabled ? { opacity: 0.5 } : {}),
      }}
      onClick={() => setConnectHover(true)}
      onMouseEnter={() => setConnectHover(true)}
      onMouseLeave={() => setConnectHover(false)}
    >
      <Backdrop
        sx={{
          position: 'absolute',
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={connectHover}
      >
        {disabled ? (
          <Button
            variant="contained"
            sx={{
              backgroundColor: '#fff',
              color: '#333',
              '&.Mui-disabled': {
                backgroundColor: '#fff',
                color: '#333',
              },
            }}
            disabled
          >
            Contact support to enable
          </Button>
        ) : (
          <Button
            variant="contained"
            color="success"
            onClick={() => onItemSelect(catalogType)}
            data-cy="catalog-card-button"
            aria-label={itemSelectText || 'Select'}
          >
            {itemSelectText || 'Select'}
          </Button>
        )}
      </Backdrop>
      <div
        style={{
          padding: 14,
        }}
      >
        <div
          style={{
            position: 'relative',
            width: size + 'px',
            height: size + 'px',
            marginRight: 10,
            float: 'left',
          }}
        >
          {image}
        </div>
        <div>
          <span
            style={{
              display: 'block',
              fontWeight: '700',
              marginBottom: 6,
            }}
          >
            {catalogType.title}
          </span>
          {catalogType.headline}
        </div>
      </div>
      <div
        style={{
          borderTop: 'solid 2px rgba(247,244,234,1)',
          padding: '6px',
          height: 25,
          position: 'absolute',
          bottom: 0,
          left: 0,
          width: '100%',
        }}
      >
        {tags}
      </div>
    </Card>
  );
};
